import { z } from "zod";

import { OfferDtoSchema } from "../../../dtos/offers";

export const GetOffersResponseBodySchema = z.object({
  offers: OfferDtoSchema.array(),
});

export type GetOffersResponseBodyType = z.infer<
  typeof GetOffersResponseBodySchema
>;
